import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
/**
 * Interceptor which provides for every https api call the api credentials
 */
export class TokenInterceptor implements HttpInterceptor {
  private uName = 'empamos_dev';
  private uPass = '759651269498421657846216579222148554871321';

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const params = request.params
      .set('uname', this.uName)
      .set('upass', this.uPass);

    const newRequest = request.clone({ params });
    return next.handle(newRequest);
  }
}
